export default __webpack_public_path__ + "images/LG.3ccfa5e.png";